/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/letter-to-larry.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/letter-to-larry.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/letter-to-larry.mdx';

const metadata = {
  slug: "letter-to-larry",
  title: "Letter to Larry",
  author: "Christian Battaglia",
  description: "Questions I prepared for a conversation with Larry Berger, CEO of Amplify — covering procurement, HQIM, the company's relationship with Emerson, and the future of K-12 curriculum technology.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-01-23T00:00:00.000Z",
  
  readTime: "4 min read",
  tags: ["Amplify","education","HQIM","leadership","Larry Berger","EdTech","K-12","product strategy"],
};

export const Route = createFileRoute('/blog/posts/letter-to-larry')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/letter-to-larry',
    image: '/og/blog/letter-to-larry.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
